/* unplugin-vue-components disabled */import { render } from "./Icon.vue?vue&type=template&id=379cfbc7&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=379cfbc7&scoped=true&lang=scss"

import exportComponent from "D:\\Develop\\Workspaces\\WeApp\\blockchain_ait_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379cfbc7"]])

export default __exports__